






import { iosCustomUrlSchemes, navigateToHlAppDeeplink } from '@/models/hl-app/custom-url-scheme'
import FullscreenNotificationLayout from '@spa/hl-app/components/fullscreen-notification/FullscreenNotificationLayout.vue'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    FullscreenNotificationLayout,
  },
})
export default class OpenExternalBrowser extends Vue {
  @Prop({ required: true })
  readonly path: string

  created(): void {
    navigateToHlAppDeeplink(iosCustomUrlSchemes.createOpenExternalBrowser(this.path))
  }
}
